<script setup lang="ts">
import Skeleton from '@/shared/ui/Skeleton/index';
import JournalCardSkeleton from '@/pages/journal/ui/Skeleton/JournalCardSkeleton.vue';

const props = withDefaults(defineProps<{ isDetailPage?: boolean }>(), {
  isDetailPage: false,
});

const isMobile: boolean = useIsMobile();
</script>

<template>
  <div
    :class="[
      'journal-card-skeleton-section',
      { _mobile: isMobile },
      { _detail: isDetailPage },
    ]"
  >
    <div v-if="!isDetailPage" class="journal-card-skeleton-section__header">
      <Skeleton width="126px" height="20px" />
    </div>
    <div class="journal-card-skeleton-section__list">
      <JournalCardSkeleton
        v-for="i in props.isDetailPage ? 8 : 4"
        :key="i"
        :is-detail-page="isDetailPage"
      />
    </div>
  </div>
</template>

<style lang="less" scoped>
.journal-card-skeleton-section {
  .flex-column(@size-x10);

  &__list {
    display: grid;
    gap: @size-x5;
    row-gap: @size-x10;
    grid-template-columns: repeat(auto-fill, minmax(23%, 1fr));
  }

  &._mobile &__list {
    row-gap: @size-x5;
    grid-template-columns: repeat(auto-fill, minmax(100%, 1fr));
  }

  &._mobile:not(._detail) &__list {
    .horizontal-scroll-snap();

    border-bottom: 0;
  }
}
</style>
